import type { ReactNode } from "react";

export function Marquee({ children }: { children: ReactNode }) {
  return (
    <div className="relative flex overflow-hidden select-none">
      <div className="flex shrink-0 items-center justify-around gap-12 min-w-full animate-scroll-left">
        {children}
      </div>
      <div
        className="flex shrink-0 items-center justify-around gap-12 min-w-full animate-scroll-left"
        aria-hidden="true"
      >
        {children}
      </div>
    </div>
  );
}
